import {combineReducers} from "redux";

import listeOffresReducer from "./listeOffres";
//import coursReducer from "./offre";


export default combineReducers({
    listeOffres : listeOffresReducer,
    //cours : coursReducer
});